export const GET_SOLICITATIONS = "GET_SOLICITATIONS";
export const ACCEPTED_COURSES_SOLICITATIONS = "ACCEPTED_COURSES_SOLICITATIONS";
export const ACCEPT_SOLICITATIONS = "ACCEPT_SOLICITATIONS";
export const DECLINE_SOLICITATIONS = "DECLINE_SOLICITATIONS";
export const DECLINED_COURSES_SOLICITATIONS = "DECLINED_COURSES_SOLICITATIONS";
